import { Box, Tab, Typography } from '@mui/material'
import React, { useState } from 'react'
import Tabs from '@mui/material/Tabs'
import { TabContext, TabPanel } from '@mui/lab'

import DeleteIconNew from '../../assets/svg/DeleteIconNew'
import DeleteWarningModal from '../../modals/deletewarningmodal'
import BreadcrumbNavigation from '../commoncomponents/breadcrumbnavigation'
import NestedTable from '../../leastcomponent/customtable/nestedTable'
import EditIconNew from '../../assets/svg/EditIconNew'
import FilterIconNew from '../../assets/svg/FilterIconNew'

const UpdateStatus = () => {
  const [value, setValue] = React.useState('1')
  const [deleteRecord, setDeleteRecord] = useState(false)
  const handleDeleteOpen = () => setDeleteRecord(true)
  const handleDeleteClose = () => setDeleteRecord(false)

  const handleChange = (event, newValue) => {
    setValue(newValue)
  }

  const mainCols = [
    { field: '#', headerName: '#', flex: 0.2 },
    { field: 'Job Card Number', headerName: 'Job Card Number', flex: 1 },
    { field: 'Job Card Name', headerName: 'Job Card Name', flex: 1 },
    { field: 'Product', headerName: 'Product', flex: 1 },
    { field: 'Qty', headerName: 'Qty', flex: 1 },
    { field: 'Customer Name', headerName: 'Customer Name', flex: 1 },
    { field: 'Submitted on', headerName: 'Submitted on', flex: 1 },
    { field: 'Due Date', headerName: 'Due Date', flex: 1 },
    { field: 'Overall completion', headerName: 'Overall completion', flex: 1 }
  ]

  const finalDataColumns = [
    { field: 'id', headerName: '#', flex: 0.2 },
    { field: 'Part Name', headerName: 'Part Name', flex: 1 },
    { field: ' Part Code', headerName: ' Part Code', flex: 1 },
    { field: 'Drawing Number', headerName: 'Drawing Number', flex: 1 },
    { field: 'Qty', headerName: 'Qty', flex: 1 },
    { field: 'Dept. sequence', headerName: 'Dept. sequence', flex: 1 },
    { field: 'Preceding dept.', headerName: 'Preceding dept.', flex: 1 },
    { field: 'Following dept.', headerName: 'Following dept.', flex: 1 },
    { field: 'Completion', headerName: 'Completion', flex: 1 },
    {
      field: 'actions',
      headerName: 'Actions',
      sortable: false,
      disableClickEventBubbling: true,
      flex: 1,
      renderCell: () => {
        return (
          <Box className="report-table-btn-main">
            <span className="report-delete">
              <EditIconNew />
            </span>
            <span className="report-delete">
              <DeleteIconNew />
            </span>
          </Box>
        )
      }
    }
  ]
  const finalData = [
    {
      no: 1,
      number: 123112125,
      name: 'jobCard 8788',
      productName: 'intex',
      quantity: 12,
      customerName: 'Customer',
      date: 10,
      dueDate: 10,
      description: 10,
      redirectLink: 'localhost:3000/dhaval',
      history: [
        {
          partName: 'Part Name',
          partCode: 123456,
          drawingNumber: 123456,
          qty: 10,
          deptSequence: 2,
          precedingDept: 'Department',
          followingDept: 'Department',
          completion: 10,
          action: 'action'
        }
      ]
    },
    {
      no: 2,
      number: 123456789,
      name: 'Job Card Name',
      productName: 'Product',
      quantity: 10,
      customerName: 'Customer',
      date: 10,
      dueDate: 10,
      description: 10,
      history: [
        {
          partName: 'Part Name',
          partCode: 123456,
          drawingNumber: 123456,
          qty: 10,
          deptSequence: 2,
          precedingDept: 'Department',
          followingDept: 'Department',
          completion: 10,
          action: 'action'
        }
      ]
    },
    {
      no: 3,
      number: 123456789,
      name: 'Job Card Name',
      productName: 'Product',
      quantity: 10,
      customerName: 'Customer',
      date: 10,
      dueDate: 10,
      description: 10
    }
  ]
  return (
    <React.Fragment>
      <Box className="production-team-head-overflow-hidden">
        <BreadcrumbNavigation
          breadCrumbData={null}
          pageTitle={'Job Card - Department Group 1'}
          backToLink={null}
        />
        <Box className="production-team-head-overflow-auto">
          <TabContext value={value}>
            <Box
              sx={{
                typography: 'body1'
              }}
              className="tab-content-padding"
            >
              <Tabs
                value={value}
                onChange={handleChange}
                aria-label="lab API tabs example"
              >
                <Tab className="tab-head" label="Approved" value="1" />
                <Tab className="tab-head" label="Pending" value="2" />
                <Tab className="tab-head" label="Ongoing" value="3" />
                <Tab className="tab-head" label="Completed" value="4" />
              </Tabs>
            </Box>
            <TabPanel value="1" className="tab-panel-padding">
              <Box>
                <Box className="common-parent-haeding-btn-div">
                  <Typography className="common-tabel-heading">
                    Approved Job cards
                  </Typography>

                  <Box className="job-card-filter">
                    {' '}
                    <FilterIconNew />
                    <Typography>Filters</Typography>
                  </Box>
                </Box>
                <NestedTable
                  rows={finalData}
                  columns={finalDataColumns}
                  mainCols={mainCols}
                />
              </Box>
            </TabPanel>
            <TabPanel value="2" className="tab-panel-padding">
              <Box>
                <Box className="common-parent-haeding-btn-div">
                  <Typography className="common-tabel-heading">
                    Pending Job cards
                  </Typography>

                  <Box className="job-card-filter">
                    {' '}
                    <FilterIconNew />
                    <Typography>Filters</Typography>
                  </Box>
                </Box>
                <NestedTable
                  rows={finalData}
                  columns={finalDataColumns}
                  mainCols={mainCols}
                />
              </Box>
            </TabPanel>
            <TabPanel value="3" className="tab-panel-padding">
              <Box>
                <Box className="common-parent-haeding-btn-div">
                  <Typography className="common-tabel-heading">
                    Ongoing Job cards
                  </Typography>

                  <Box className="job-card-filter">
                    {' '}
                    <FilterIconNew />
                    <Typography>Filters</Typography>
                  </Box>
                </Box>
                <NestedTable
                  rows={finalData}
                  columns={finalDataColumns}
                  mainCols={mainCols}
                />
              </Box>
            </TabPanel>
            <TabPanel value="4" className="tab-panel-padding">
              <Box>
                <Box className="common-parent-haeding-btn-div">
                  <Typography className="common-tabel-heading">
                    Completed Job cards
                  </Typography>

                  <Box className="job-card-filter">
                    {' '}
                    <FilterIconNew />
                    <Typography>Filters</Typography>
                  </Box>
                </Box>
                <NestedTable
                  rows={finalData}
                  columns={finalDataColumns}
                  mainCols={mainCols}
                />
              </Box>
            </TabPanel>
          </TabContext>
        </Box>
        {deleteRecord && (
          <DeleteWarningModal
            open={deleteRecord}
            handleOpen={handleDeleteOpen}
            handleClose={handleDeleteClose}
          />
        )}
      </Box>
    </React.Fragment>
  )
}

export default UpdateStatus
